var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("register-emisor", { ref: "RegisterEmisor" }),
      _c("show-emisor", { ref: "ShowEmisor" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }